// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"3":"templates","348":"chat","443":"about"}[chunkId] + "." + {"3":"30d30b44","348":"108344db","443":"e61e47a5"}[chunkId] + ".js";
};